/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { lazy } from "react";
import { Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";

import { Layout, ContentRoute } from "../_metronic/layout";
import BasePage from "./BasePage";
import BasePagePublic from "./BasePagePublic";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";

import Login from "./modules/Auth/pages/Login";
import Registration from "./modules/Auth/pages/Registration";
import ForgotPassword from "./modules/Auth/pages/ForgotPassword";
import ResetPassword from "./modules/Auth/pages/ResetPassword";

const MapsPage = lazy(() => import("./icomos/pages/maps/MapsPage"));

export function Routes({ history }) {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual
  );
  return (
    <Switch>
      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      <ContentRoute
        path="/auth/login"
        component={() => {
          return (
            <AuthPage>
              <Login />
            </AuthPage>
          );
        }}
      />
      <ContentRoute
        path="/auth/registration"
        component={() => {
          return (
            <AuthPage>
              <Registration />
            </AuthPage>
          );
        }}
      />
      <ContentRoute
        path="/auth/forgot-password"
        component={() => {
          return (
            <AuthPage>
              <ForgotPassword />
            </AuthPage>
          );
        }}
      />
      <ContentRoute
        path="/auth/reset-password/:token"
        component={() => {
          return (
            <AuthPage>
              <ResetPassword />
            </AuthPage>
          );
        }}
      />

      <Route path="/maps" component={MapsPage} />

      <Route
        path="/"
        component={() => {
          if (!isAuthorized) {
            return (
              <Layout>
                <BasePagePublic />
              </Layout>
            );
          } else {
            return (
              <Layout>
                <BasePage />
              </Layout>
            );
          }
        }}
      />
    </Switch>
  );
}
